import { combineReducers } from 'redux';
import * as key from 'store/constants';
import user from './userReducer';
import alerts from './alertReducer';
import errors from './errorReducer';
import loading from './loadingReducer';
import imageUpload from './imageUploadReducer';
import pagination from './paginationReducer';
import sort from './sortReducer';
import magicAlgorithmData from './magicAlgorithmReducer';
import jobFormActiveSection from './jobFormActiveSection';
import jobFormValidSections from './jobFormValidSections';
import requirementsTags from './requirementsTagsReducer';
import fillAdvisorData from './fillAdvisorData';
import tryoutBadges from './tryoutBadges';
import auth from './authReducer';
import postMessage from './postMessage';
import featureUserSettings from './featureUserSettingsReducer';
import customerPermissions from './customerPermissions';
import wandasPageReducer from './wandaPageReducer';
import { preferredModalReducer } from './preferredModalReducer';
import { browserStorage } from './browserStroage';
import { reducer } from './messagePageReducer';

const noOpReducer = (state = {}) => state;

// right now, we have no way to set themes, so no need to reduce them
const rootReducer = () => combineReducers({
  [key.CUSTOMER_PERMISSIONS]: customerPermissions,
  [key.POST_MESSAGE]: postMessage,
  [key.AUTH]: auth,
  [key.TRYOUT_BADGES]: tryoutBadges,
  [key.FILL_ADVISOR_DATA]: fillAdvisorData,
  [key.PAGING]: pagination,
  [key.USER]: user,
  [key.FEATURE_USER_SETTINGS]: featureUserSettings,
  [key.ALERTS]: alerts,
  [key.ERRORS]: errors,
  [key.LOADING]: loading,
  [key.IMAGE_UPLOAD]: imageUpload,
  [key.SORT]: sort,
  [key.MESSAGES_PAGE]: reducer,
  [key.WANDAS_PAGE]: wandasPageReducer,
  [key.MAGIC_ALGORITHM]: magicAlgorithmData,
  [key.JOB_FORM_ACTIVE_SECTION]: jobFormActiveSection,
  [key.JOB_FORM_VALID_SECTIONS]: jobFormValidSections,
  [key.REQUIREMENTS_TAGS]: requirementsTags,
  [key.THEME]: noOpReducer,
  [key.BROWSER_STORAGE]: browserStorage,
  [key.PREFERRED_MODAL]: preferredModalReducer
});

export default rootReducer;
